import Button from '@jetbrains/ring-ui/components/button/button'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip'
import {memo} from 'react'

import {useBooleanQueryParam} from '../../../../../../hooks/routes'
import {
  useEditPipeline,
  useSaveYAMLChangesHandler,
} from '../../../EditPipelinePage/EditPipelinePage.hooks'
import useSaveChangesError from '../../../EditPipelinePage/SaveChanges/hooks/useSaveChangesError'
import {usePipelineId} from '../../../hooks/pipeline'
import {useSaveChangesState} from '../hooks/useSaveChangesState'

const popupProps = {
  offset: 10,
  autoCorrectTopOverflow: true,
  directions: [Directions.BOTTOM_CENTER],
}

interface Props {
  className?: string
}
function SaveChangesButton(props: Props) {
  const {className} = props
  const pipelineId = usePipelineId()
  const isYaml = useBooleanQueryParam('yaml')

  const saveChangesError = useSaveChangesError(pipelineId)
  const editPipeline = useEditPipeline()
  const [saveYAMLChangesHandler] = useSaveYAMLChangesHandler()

  const {hasErrors, isLoading} = useSaveChangesState()

  const errorJobsLabel = isYaml ? '' : saveChangesError.errorJobsLabel
  const handlerSaveButtonClick = isYaml
    ? saveYAMLChangesHandler
    : editPipeline.handlerSaveButtonClick

  return (
    <Tooltip popupProps={popupProps} title={errorJobsLabel}>
      <Button
        primary
        className={className}
        disabled={hasErrors}
        onClick={handlerSaveButtonClick}
        loader={isLoading}
      >
        {'Save'}
      </Button>
    </Tooltip>
  )
}

export default memo(SaveChangesButton)
